import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["requisite-status-dot", 'requisite-status-dot--' + _ctx.status]),
    title: _ctx.helper.trans('requisites.status_' + _ctx.status)
  }, null, 10, _hoisted_1)), [
    [
      _directive_b_tooltip,
      void 0,
      void 0,
      { hover: true }
    ]
  ])
}